/**
 * Global service, which implements global configuration access. This is an 
 * analog of Angular's environment.ts file. For now it takes a configuration
 * from  conf.js file. In future, you may load it from some service and store
 * it on BE side.
 * 
 * @author Ramesh Guptha Kotha
 */
import { Injectable } from "@angular/core";
/**
 * Interface of global configuration. See conf.js file for details. User may
 * change it without app rebuild.
 */

interface oidcAuthConfig  {
    issuer                  :string,
    clientId                :string,
    redirectURL             :string,
    post_logout_redirect_uri:string,
    authorization_endpoint  :string,
    token_endpoint          :string,
    jwks_uri                :string,
    end_session_endpoint    :string,
    revocation_endpoint     :string,
    userinfo_endpoint       :string
}

interface GlobalConfig {
  
    environment: {
        production         : boolean,
        baseUrl            : string,
        oidcConfig         : oidcAuthConfig,
        apiRootUrl         : string,
        serviceNowUrl      : string,
        envName            : string,
        villageWebUrl      : string
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfService {
    static conf: GlobalConfig = window['conf'];
}